import React, { useState } from "react";
import { useParams } from "react-router-dom";
import projects from "./ProjectData";

function LocationMap() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  const project = projects.find((item) => item.id === parseInt(id));

  if (!project) {
    return <h2>Project Not Found</h2>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <h2>{project.title} - Location Map</h2>

      {loading && <h3>Loading Map...</h3>}

<img src={project.locationImage} alt="Location" width="100%" />
     <a href={project.map} target="_blank" rel="noopener noreferrer">
  <button>Open Location in Google Maps</button>
</a>
    </div>
  );
}

export default LocationMap;